import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UiComponents, BackArrowIcon, PLusIcon } from "@simulanisindia/ui";
import { checkPermissionExist } from "../../utils/general";
import { ROLES_CREATE_PERMISSION } from "../../constant/permission";
import { ActivateSearchIcon } from "../../Icons";
import SearchbarMobile from "../../components/ForMobile/SearchbarMobile";
import ScrollFixedSearch from "../../components/ForMobile/ScrollFixedSearch";

const { BackButton } = UiComponents;

const RoleHeader = ({ isMobileView, showBackBtn, roleheader = false }) => {
  const navigate = useNavigate();
  const backClick = () => navigate(-1);

  const mobSearchRef = useRef(null);
  ScrollFixedSearch(mobSearchRef, "scroll-up");

  return (
    <>
      {!isMobileView ? (
        <div className="page-title with-fuctions">
          <div className="title-here">
            <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
            <h6>Role Management</h6>
          </div>
          {checkPermissionExist(ROLES_CREATE_PERMISSION) && (
            <div className="role-button">
              <button onClick={() => navigate(`/roles/create`)} className="normalbtn">
                <PLusIcon /> New Role
              </button>
            </div>
          )}
        </div>
      ) : (
        <>
          {roleheader ? (
            <div ref={mobSearchRef} className="mob-header mobilesticky">
              <div className={`page-title mob role ${showBackBtn && "with-backBtn"}`}>
                {showBackBtn && (
                  <div className="backButtonWrapper">
                    <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
                  </div>
                )}
                <h6>Role Management</h6>
              </div>
            </div>
          ) : (
            <>
              <div ref={mobSearchRef} className="mob-header mobilesticky">
                <div className={`page-title mob ${showBackBtn && "with-backBtn"}`}>
                  {showBackBtn && (
                    <div className="backButtonWrapper">
                      <BackButton onBackClick={backClick} Icon={<BackArrowIcon />} />
                    </div>
                  )}
                  <div className="mobSearchParent">
                    <SearchbarMobile />
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default RoleHeader;
